import styled from "styled-components";

export const GameIframeBox = styled.iframe<{maxWidth: string; maxHeight: string}>`
  max-width: ${props => props.maxWidth};
  max-height: ${props => props.maxHeight};
  width: 100%;
  height: 100%;
  border: none;
  overflow: scroll;
`